import { setSpecificMessage, nanoid } from "valibot";
setSpecificMessage(
  nanoid,
  (issue) => `Nano ID invalide: reçu ${issue.received}`,
  "fr"
);